export default __webpack_public_path__ + "static/media/icon-settings-facebook.68cb7cb6.svg";